export enum WordProcessor {
    WORD = "application/msword",
    TXT = "text/plain"
}
